// Local translations
export const T = {
  en_GB: {
    thankYou: "Thank You!",
    submittedSuccessfully: "Your information has been submitted successfully",
    thankYouName: (name: string) => `Thank you, ${name}!`,
    responsesReviewed: "Your responses have been saved and your advisor will review them shortly.",
    downloadSummary: "Download Summary",
    pdfReady: "Your PDF is ready for download",
    generatePdfDescription: "Generate a PDF summary of your responses",
    generatePdf: "Generate PDF",
    downloaded: "Downloaded - Click to download again",
    downloadPdf: "Download PDF",
    signDocument: "Sign Document",
    documentSigned: "Document has been signed",
    drawSignature: "Draw your signature below using your mouse, trackpad, or finger",
    clear: "Clear",
    signing: "Signing...",
    signDocumentButton: "Sign Document",
    signedSuccessfully: "Document Signed Successfully",
    done: "Done",
    pleaseProvideSignature: "Please provide your signature",
    signatureAgreement: "By signing, you agree that this is a legally binding electronic signature",
    failedToGeneratePdf: "Failed to generate PDF",
    failedToSign: "Failed to complete signature",
  },
  nb_NO: {
    thankYou: "Takk!",
    submittedSuccessfully: "Informasjonen din har blitt sendt inn",
    thankYouName: (name: string) => `Takk, ${name}!`,
    responsesReviewed: "Svarene dine har blitt lagret og din rådgiver vil gjennomgå dem snart.",
    downloadSummary: "Last ned sammendrag",
    pdfReady: "PDF-en din er klar for nedlasting",
    generatePdfDescription: "Generer et PDF-sammendrag av svarene dine",
    generatePdf: "Generer PDF",
    downloaded: "Lastet ned - Klikk for å laste ned igjen",
    downloadPdf: "Last ned PDF",
    signDocument: "Signer dokument",
    documentSigned: "Dokumentet har blitt signert",
    drawSignature: "Tegn signaturen din nedenfor med mus, styreflate eller finger",
    clear: "Tøm",
    signing: "Signerer...",
    signDocumentButton: "Signer dokument",
    signedSuccessfully: "Dokument signert",
    done: "Ferdig",
    pleaseProvideSignature: "Vennligst oppgi signaturen din",
    signatureAgreement:
      "Ved å signere godtar du at dette er en juridisk bindende elektronisk signatur",
    failedToGeneratePdf: "Kunne ikke generere PDF",
    failedToSign: "Kunne ikke fullføre signering",
  },
} as const;
